import { placements as a } from "./index666.js";
import { CircleClose as o } from "./index537.js";
import { disabledTimeListsProps as l } from "./index634.js";
import { buildProps as r, definePropType as e } from "./index601.js";
import { useAriaProps as p } from "./index650.js";
import { useEmptyValuesProps as i } from "./index583.js";
import { useSizeProp as n } from "./index607.js";
import { useTooltipContentProps as t } from "./index680.js";
const S = r({
  /**
   * @description this prop decides if the date picker panel pops up when the input is focused
   */
  automaticDropdown: {
    type: Boolean,
    default: !0
  },
  /**
   * @description same as `id` in native input
   */
  id: {
    type: e([Array, String])
  },
  /**
   * @description same as `name` in native input
   */
  name: {
    type: e([Array, String])
  },
  /**
   * @description custom class name for TimePicker's dropdown
   */
  popperClass: t.popperClass,
  /**
   * @description custom style for TimePicker's dropdown
   */
  popperStyle: t.popperStyle,
  /**
   * @description format of the displayed value in the input box
   */
  format: String,
  /**
   * @description optional, format of binding value. If not specified, the binding value will be a Date object
   */
  valueFormat: String,
  /**
   * @description optional, format of the date displayed in input's inner panel
   */
  dateFormat: String,
  /**
   * @description optional, format of the time displayed in input's inner panel
   */
  timeFormat: String,
  /**
   * @description type of the picker
   */
  type: {
    type: String,
    default: ""
  },
  /**
   * @description whether to show clear button
   */
  clearable: {
    type: Boolean,
    default: !0
  },
  /**
   * @description Custom clear icon component
   */
  clearIcon: {
    type: e([String, Object]),
    default: o
  },
  /**
   * @description whether the input is editable
   */
  editable: {
    type: Boolean,
    default: !0
  },
  /**
   * @description Custom prefix icon component
   */
  prefixIcon: {
    type: e([String, Object]),
    default: ""
  },
  /**
   * @description size of Input
   */
  size: n,
  /**
   * @description whether TimePicker is read only
   */
  readonly: Boolean,
  /**
   * @description whether TimePicker is disabled
   */
  disabled: {
    type: Boolean,
    default: void 0
  },
  /**
   * @description placeholder in non-range mode
   */
  placeholder: {
    type: String,
    default: ""
  },
  /**
   * @description [popper.js](https://popper.js.org/docs/v2/) parameters
   */
  popperOptions: {
    type: e(Object),
    default: () => ({})
  },
  /**
   * @description binding value, if it is an array, the length should be 2
   */
  modelValue: {
    type: e([Date, Array, String, Number]),
    default: ""
  },
  /**
   * @description range separator
   */
  rangeSeparator: {
    type: String,
    default: "-"
  },
  /**
   * @description placeholder for the start date in range mode
   */
  startPlaceholder: String,
  /**
   * @description placeholder for the end date in range mode
   */
  endPlaceholder: String,
  /**
   * @description optional, default date of the calendar
   */
  defaultValue: {
    type: e([Date, Array])
  },
  /**
   * @description optional, the time value to use when selecting date range
   */
  defaultTime: {
    type: e([Date, Array])
  },
  /**
   * @description whether to pick a time range
   */
  isRange: Boolean,
  ...l,
  /**
   * @description a function determining if a date is disabled with that date as its parameter. Should return a Boolean
   */
  disabledDate: {
    type: Function
  },
  /**
   * @description set custom className
   */
  cellClassName: {
    type: Function
  },
  /**
   * @description an object array to set shortcut options
   */
  shortcuts: {
    type: Array,
    default: () => []
  },
  /**
   * @description whether to pick time using arrow buttons
   */
  arrowControl: Boolean,
  /**
   * @description input tabindex
   */
  tabindex: {
    type: e([String, Number]),
    default: 0
  },
  /**
   * @description whether to trigger form validation
   */
  validateEvent: {
    type: Boolean,
    default: !0
  },
  /**
   * @description unlink two date-panels in range-picker
   */
  unlinkPanels: Boolean,
  /**
   * @description position of dropdown
   */
  placement: {
    type: e(String),
    values: a,
    default: "bottom"
  },
  /**
   * @description list of possible positions for dropdown
   */
  fallbackPlacements: {
    type: e(Array),
    default: ["bottom", "top", "right", "left"]
  },
  ...i,
  ...p(["ariaLabel"]),
  /**
   * @description whether to show the now button
   */
  showNow: {
    type: Boolean,
    default: !0
  },
  /**
   * @description whether to show footer
   */
  showConfirm: {
    type: Boolean,
    default: !0
  },
  /**
   * @description whether to show footer
   */
  showFooter: {
    type: Boolean,
    default: !0
  },
  /**
   * @description whether to show the number of the calendar week
   */
  showWeekNumber: Boolean
}), b = r({
  id: {
    type: e(Array)
  },
  name: {
    type: e(Array)
  },
  modelValue: {
    type: e([Array, String])
  },
  startPlaceholder: String,
  endPlaceholder: String,
  disabled: Boolean
});
export {
  S as timePickerDefaultProps,
  b as timePickerRangeTriggerProps
};
